import { render } from "./Languages.vue?vue&type=template&id=a6e99a08&scoped=true"
import script from "./Languages.vue?vue&type=script&lang=js"
export * from "./Languages.vue?vue&type=script&lang=js"

import "./Languages.vue?vue&type=style&index=0&id=a6e99a08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6e99a08"]])

export default __exports__